export default __webpack_public_path__ + "97747bdb8ad2834af41799232048aeb1.webp";